import Progress from './progress';

export type { ProgressAriaProps, ProgressProps } from './progress';

export default Progress;
